var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetThingsDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.8 167.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.78,63.34H61.43A35.83,35.83,0,0,0,97.26,99.16h15.35A35.83,35.83,0,0,0,76.78,63.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.61,101.08a1.89,1.89,0,0,1-1.47-.69A138.62,138.62,0,0,0,78.87,73.75a1.92,1.92,0,0,1,2-3.31,139.94,139.94,0,0,1,33.26,27.5,1.92,1.92,0,0,1-1.48,3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.45,78.69H163.8A35.83,35.83,0,0,1,128,114.52H112.62A35.83,35.83,0,0,1,148.45,78.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.62,116.44a1.93,1.93,0,0,1-1.48-3.15A140,140,0,0,1,144.4,85.8a1.92,1.92,0,1,1,2,3.3,138.8,138.8,0,0,0-32.27,26.65A1.92,1.92,0,0,1,112.62,116.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,117.08h15.35a35.83,35.83,0,0,1-35.83,35.83H51.19A35.83,35.83,0,0,1,87,117.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.19,154.83a1.92,1.92,0,0,1-1.47-3.15A139.61,139.61,0,0,1,83,124.19a1.92,1.92,0,0,1,2,3.31,138.62,138.62,0,0,0-32.27,26.64A1.89,1.89,0,0,1,51.19,154.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.36,101.73H0a35.83,35.83,0,0,0,35.83,35.83H51.18A35.83,35.83,0,0,0,15.36,101.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.19,139.48a1.94,1.94,0,0,1-1.48-.69,138.61,138.61,0,0,0-32.26-26.65,1.92,1.92,0,1,1,1.95-3.3,139.5,139.5,0,0,1,33.26,27.49,1.92,1.92,0,0,1-1.47,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.24,167.63H23.06a1.92,1.92,0,1,1,0-3.84H74.24a1.92,1.92,0,0,1,0,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.87,167.63H84.48a1.92,1.92,0,0,1,0-3.84h38.39a1.92,1.92,0,0,1,0,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.78,167.63h-7.67a1.92,1.92,0,0,1,0-3.84h7.67a1.92,1.92,0,0,1,0,3.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 112.63,
    cy: 30.07,
    r: 28.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.63,60.14A30.07,30.07,0,1,1,142.7,30.07,30.1,30.1,0,0,1,112.63,60.14Zm0-56.3a26.23,26.23,0,1,0,26.23,26.23A26.26,26.26,0,0,0,112.63,3.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 130.23,
    cy: 30.07,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 95.03,
    cy: 30.07,
    r: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.65,46.89a10.06,10.06,0,0,1-9.43-6,1.92,1.92,0,0,1,3.54-1.49,6.31,6.31,0,0,0,5.89,3.62c3.46,0,6.27-2.48,6.27-5.53,0-2.52-1.09-5.53-6.3-5.53-7.46,0-10.12-4.84-10.12-9.37,0-5.16,4.54-9.36,10.12-9.36a10.08,10.08,0,0,1,9.43,6,1.92,1.92,0,0,1-3.54,1.49,6.34,6.34,0,0,0-5.89-3.62c-3.46,0-6.28,2.48-6.28,5.53,0,2.53,1.09,5.53,6.28,5.53,7.48,0,10.14,4.84,10.14,9.37C122.76,42.69,118.22,46.89,112.65,46.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.62,17.09a1.92,1.92,0,0,1-1.92-1.91v-4.1a1.92,1.92,0,0,1,3.84,0v4.1A1.92,1.92,0,0,1,112.62,17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.62,51a1.92,1.92,0,0,1-1.92-1.91V45a1.92,1.92,0,0,1,3.84,0v4.1A1.92,1.92,0,0,1,112.62,51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 51.2,
    cy: 68.46,
    r: 28.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.2,98.53A30.07,30.07,0,1,1,81.28,68.46,30.1,30.1,0,0,1,51.2,98.53Zm0-56.3A26.24,26.24,0,1,0,77.44,68.46,26.26,26.26,0,0,0,51.2,42.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.15,68.46a2.35,2.35,0,1,1-2.35-2.34A2.35,2.35,0,0,1,71.15,68.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,68.46a2.35,2.35,0,1,1-2.34-2.34A2.35,2.35,0,0,1,36,68.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.63,167.63a1.92,1.92,0,0,1-1.92-1.92V58.22a1.92,1.92,0,0,1,3.84,0V165.71A1.92,1.92,0,0,1,112.63,167.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.2,167.63a1.92,1.92,0,0,1-1.92-1.92V96.62a1.92,1.92,0,1,1,3.84,0v69.09A1.92,1.92,0,0,1,51.2,167.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,70.23A6,6,0,0,0,58,67.78a5.52,5.52,0,0,0,2.28-2.4,7.3,7.3,0,0,0,.83-3.51,7.13,7.13,0,0,0-.7-3.17,6.48,6.48,0,0,0-1.72-2.26,5.27,5.27,0,0,0-2.33-1.12c-.3-.06-.66-.11-1.07-.15l0-5.47H52.83l0,5.37H49.6l0-5.36H47.13l0,5.36H40.76v2h2.75l.1,23.13H40.87v2l2.75,0h3.64l0,5h2.45l0-5h1.51l1.75,0,0,5h2.45l0-5.06c.54,0,1-.06,1.23-.1a5.66,5.66,0,0,0,3-1.3,7,7,0,0,0,1.92-2.8,9.45,9.45,0,0,0,.69-3.61A7.47,7.47,0,0,0,61.17,70.23Zm-6.7-10.55a2.43,2.43,0,0,1,1.7.94,3.36,3.36,0,0,1,.58,2.05,3.21,3.21,0,0,1-.65,2.13,2.78,2.78,0,0,1-1.81,1,32.34,32.34,0,0,1-3.27.1l-3,0,0-6.29h2.58C52.74,59.59,54,59.62,54.47,59.68ZM57,76.4a2.7,2.7,0,0,1-1.64,1.09,17.24,17.24,0,0,1-3.08.18l-4.17,0,0-7.27,3.64,0a12.81,12.81,0,0,1,4,.38A2.87,2.87,0,0,1,57.13,72a4.18,4.18,0,0,1,.5,2.08A3.92,3.92,0,0,1,57,76.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetThingsDone);
export default __webpack_public_path__ + "static/media/get_things_done.69015190d497f51b787d9a738385ad49.svg";
export { ForwardRef as ReactComponent };